import {extend} from 'quasar';
import {Pagination} from '@/oauth/Pagination';

export class Page<T> implements Page<T> {
    public content: T[] = [];
    public empty = true;
    public first = true;
    public last = false;
    public number = 0;
    public numberOfElements = 0;
    public size = 0;
    public sort = {
        sorted: false,
        unsorted: true,
        empty: true,
    };
    public totalElements = 0;
    public totalPages = 0;
    
    public static of(ip: Page<any>) {
        return extend(new Page(), ip) as Page<any>;
    }
    
    public getPagination(): Pagination {
        const pagination = new Pagination();
        pagination.page = this.number + 1;
        pagination.rowsPerPage = this.size;
        pagination.rowsNumber = this.totalElements;
        return pagination;
    }
}
